var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"attachment-icon"},[(_vm.iconName)?_c('img',{attrs:{"src":require('@/assets/icons/attachments-icons/' + _vm.iconName + '')},on:{"click":_vm.onIconClick}}):_vm._e(),(_vm.tooltipText)?_c('span',{staticClass:"tooltipText"},[_vm._v(_vm._s(_vm.tooltipText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }